export const hasPasteMenuHighlight = (node) => {
  if (Array.isArray(node.menu)) {
    for (const item of node.menu) {
      if (
        [9, 6].includes(item.id) &&
        item.enabled === true &&
        item.highlight === true
      ) {
        return true;
      }
    }
  }
  if (Array.isArray(node.configurations)) {
    for (const item of node.configurations) {
      if (hasPasteMenuHighlight(item)) {
        return true;
      }
    }
  }

  return false;
};

export const updateTopologyItemOrderCode = ({
  topology,
  id,
  orderCode,
  pimId,
  presentation,
  selectedAccessories,
}) => {
  const updateConfig = (configList) =>
    configList.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          orderCode,
          presentation,
          pimId,
          selectedAccessories,
        };
      }

      if (Array.isArray(item.configurations)) {
        return {
          ...item,
          configurations: updateConfig(item.configurations),
        };
      }

      return item;
    });

  return topology.map((topoItem) => {
    if (Array.isArray(topoItem.configurations)) {
      return {
        ...topoItem,
        configurations: updateConfig(topoItem.configurations),
      };
    }
    return topoItem;
  });
};
